import React from 'react';
import { Mail, Linkedin } from 'lucide-react';
import RevealOnScroll from '../../hooks/useRevealOnScroll';
import { useTranslation } from '../../hooks/useTranslation';

export const ContactSection = () => {
    const { t } = useTranslation();

    return (
        <section id="contact" className="py-20 px-6 bg-[#0d0d0d] relative overflow-hidden">
            {/* Decorative Circle */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#d92323]/5 rounded-full blur-3xl pointer-events-none"></div>

            <div className="container mx-auto relative z-10 max-w-4xl text-center">
                <RevealOnScroll>
                    <h2 className="text-5xl font-bold text-white mb-6">{t('contactTitle')}</h2>
                    <p className="text-xl text-[#7b7b7b] mb-12">
                        {t('contactDescription')}
                    </p>

                    <div className="flex flex-col md:flex-row justify-center gap-6 mb-16">
                        <a href="mailto:taher.ayadi03@gmail.com" className="flex items-center justify-center gap-3 px-8 py-4 bg-[#d92323] hover:bg-[#b91b1b] text-white rounded-lg font-bold transition-all hover:shadow-[0_0_20px_rgba(217,35,35,0.4)] group">
                            <Mail className="w-5 h-5 group-hover:scale-110 transition-transform" />
                            {t('sendEmail')}
                        </a>
                        <a href="https://www.linkedin.com/in/taherayadi" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 px-8 py-4 bg-[#141414] border border-[#732424]/50 hover:border-[#d92323] text-white rounded-lg font-bold transition-all group">
                            <Linkedin className="w-5 h-5 group-hover:text-[#d92323] transition-colors" />
                            {t('linkedinProfile')}
                        </a>
                    </div>
                </RevealOnScroll>

                <footer className="pt-12 border-t border-[#732424]/20 text-[#7b7b7b] text-sm">
                    <p>&copy; {new Date().getFullYear()} Taher Ayadi.</p>
                </footer>
            </div>
        </section>
    );
};